
export const FilterUtils = () => {
  const selectFilter = (selectedFilters, filterType, name, value) => {
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let existingFilter = null
    if (currentSelectedFilters[filterType]) {
      existingFilter = currentSelectedFilters[filterType].find(filter => filter.name === name)
    }

    if (existingFilter) {
      if (filterType === 'string_filters') {
        const valuesSet = new Set(existingFilter.values)
        valuesSet.add(value)
        existingFilter.values = [...valuesSet]
      } else {
        existingFilter.values = [value]
      }
    } else {
      const newFilter = {
        name: name,
        values: [value]
      }
      currentSelectedFilters[filterType].push(newFilter)
    }
    // Honestly, this feels a little simplistic, but it is the way
    // that rails handles it, so... ¯\_(ツ)_/¯
    return JSON.stringify(currentSelectedFilters).replace(/&/g, '\\u0026')
  }

  const deselectFilter = (selectedFilters, filterType, name, value) => {
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let filterIndex = -1
    if (currentSelectedFilters[filterType]) {
      filterIndex = currentSelectedFilters[filterType].findIndex(filter => filter.name === name && filter.values.includes(value))
    }

    if (filterIndex !== -1) {
      const existingFilter = currentSelectedFilters[filterType][filterIndex]
      if (existingFilter.values.length > 1) {
        const valueIndex = existingFilter.values.findIndex(val => val === value)
        existingFilter.values.splice(valueIndex, 1)
      } else {
        currentSelectedFilters[filterType].splice(filterIndex, 1)
      }
    }
    return JSON.stringify(currentSelectedFilters)
  }

  const selectMinMaxFilter = (selectedFilters, name, min, max) => {
    const filterType = 'number_range_filters'
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let existingMinFilter; let existingMaxFilter = null
    if (currentSelectedFilters[filterType]) {
      existingMinFilter = currentSelectedFilters[filterType].find(filter => filter.name === `${name} (min)`)
      existingMaxFilter = currentSelectedFilters[filterType].find(filter => filter.name === `${name} (max)`)
    }

    if (existingMinFilter && min >= 0) {
      existingMinFilter.gte = min
    } else {
      const newFilter = {
        name: `${name} (min)`,
        gte: min
      }
      currentSelectedFilters[filterType].push(newFilter)
    }

    if (existingMaxFilter && max > 0) {
      existingMaxFilter.lte = max
    } else {
      const newFilter = {
        name: `${name} (max)`,
        lte: max
      }
      currentSelectedFilters[filterType].push(newFilter)
    }
    return JSON.stringify(currentSelectedFilters)
  }

  const deselectMinMaxFilter = (selectedFilters, name) => {
    const filterType = 'number_range_filters'
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let existingMinFilterIndex; let existingMaxFilterIndex = null
    if (currentSelectedFilters[filterType]) {
      existingMinFilterIndex = currentSelectedFilters[filterType].findIndex(filter => filter.name === `${name} (min)`)
      existingMaxFilterIndex = currentSelectedFilters[filterType].findIndex(filter => filter.name === `${name} (max)`)
    }

    // noinspection JSIncompatibleTypesComparison
    if (existingMinFilterIndex !== -1 && existingMaxFilterIndex !== -1) {
      let index = existingMinFilterIndex
      if (existingMaxFilterIndex < existingMinFilterIndex) {
        index = existingMinFilterIndex
      }
      currentSelectedFilters[filterType].splice(index, 2)
    }
    return JSON.stringify(currentSelectedFilters)
  }

  const selectAtLeastFilter = (selectedFilters, name, min, max) => {
    const filterType = 'number_range_filters'
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let existingFilter = null
    if (currentSelectedFilters[filterType]) {
      existingFilter = currentSelectedFilters[filterType].find(filter => filter.name === `${name}`)
    }

    if (existingFilter && max > 0) {
      existingFilter.gte = min
      existingFilter.lte = max
    } else {
      const newFilter = {
        name: `${name}`,
        gte: min,
        lte: max
      }
      currentSelectedFilters[filterType].push(newFilter)
    }
    return JSON.stringify(currentSelectedFilters)
  }

  const deselectAtLeastFilter = (selectedFilters, name) => {
    const filterType = 'number_range_filters'
    const currentSelectedFilters = JSON.parse(selectedFilters)
    let existingFilterIndex = null
    if (currentSelectedFilters[filterType]) {
      existingFilterIndex = currentSelectedFilters[filterType].findIndex(filter => filter.name === name)
    }
    if (existingFilterIndex !== -1) {
      currentSelectedFilters[filterType].splice(existingFilterIndex, 1)
    }
    return JSON.stringify(currentSelectedFilters)
  }

  return {
    selectFilter,
    deselectFilter,
    selectMinMaxFilter,
    deselectMinMaxFilter,
    selectAtLeastFilter,
    deselectAtLeastFilter
  }
}
export default FilterUtils
